import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  form: {
    padding: `${theme.spacing(2)} 0`,
    fontSize: '14px',
  },

  formLabel: {
    fontFamily: 'Source Sans Pro Bold',
    marginBottom: theme.spacing(0),
    '&:not(:first-child)': {
      marginTop: theme.spacing(2.4),
    },
  },

  formSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },

  formControl: {
    marginTop: theme.spacing(1),
  },

  formSubSection: {
    backgroundColor: '#f6f6f6',
    margin: `0 ${theme.spacing(-2)}`,
  },

  search: {
    width: '100%',
    padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
  },

  loader: {
    alignItems: 'center',
    marginTop: theme.spacing(5),
  },

  chipList: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  chip: { margin: theme.spacing(0.2) },

  error: {
    color: '#b22222',
    borderColor: '#b22222',
  },

  select: {
    height: 33,
    marginTop: theme.spacing(0.6),
  },

  smallPrint: {
    margin: `${theme.spacing(0.6)} 0 0 0`,
    paddingRight: theme.spacing(1),
    fontSize: '14px',
    color: theme.palette.text.primary,
  },
})
